module.exports = __webpack_public_path__ + "static/media/logo_vertical.40fca27d.png";